/**
 * Helper for inline edit flow: run clearEdit only when the update succeeds.
 * If onUpdate returns a Promise, clear only in .then(); on rejection the cell stays in edit mode.
 */
export function clearEditOnSuccess(result: void | Promise<void>, clearEdit: () => void): void {
  if (result != null && typeof (result as Promise<void>).then === 'function') {
    (result as Promise<void>).then(clearEdit).catch(() => {
      /* no-op: keep cell in edit mode on error */
    });
  } else {
    clearEdit();
  }
}
